export function ticketIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/my-account\/tickets\/([A-Za-z0-9_-]{1,128})\/?$/);
  return match?.[1] ?? null;
}
